import { createContext, useContext, useState } from 'react'
import { useTranslation } from 'react-i18next'

const LanguageContext = createContext()

export const LanguageProvider = ({ children }) => {
  const { i18n } = useTranslation()
  const [language, setLanguage] = useState(
    localStorage.getItem('language') || 'en',
  )

  const changeLanguage = (newLang) => {
    i18n.changeLanguage(newLang)
    setLanguage(newLang)
    localStorage.setItem('language', newLang)
    document.dir = newLang === 'ar' ? 'rtl' : 'ltr'
    // document.body.classList.remove('rtl-text', 'ltr-text')
    // document.body.classList.add(newLang === 'ar' ? 'rtl-text' : 'ltr-text')
  }

  return (
    <LanguageContext.Provider value={{ language, changeLanguage }}>
      {children}
    </LanguageContext.Provider>
  )
}

export const useLanguage = () => useContext(LanguageContext)
